import { usePromoteFormState } from '../../../../../../formContext';

type Result = ModelHookResult<{
	displayed: boolean;
}>;

export function useGeneralErrorMessage(): Result {
	const [{ formState }] = usePromoteFormState();

	return {
		data: {
			displayed: formState.status === 'error',
		},
	};
}
